import script from "./LoginPopup.vue?vue&type=script&setup=true&lang=ts"
export * from "./LoginPopup.vue?vue&type=script&setup=true&lang=ts"

import "./LoginPopup.vue?vue&type=style&index=0&id=12086b42&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-12086b42"]])

export default __exports__